import { ThemeSwitcher } from '@components/ThemeSwitcher';
import { useUIStore } from '@store/uiStore';
import { SectionHeader } from './shared';
import styles from '../DemoPage.module.scss';

export const ThemeSwitcherSection = () => {
  const { theme } = useUIStore();

  return (
    <section className={styles.section}>
      <SectionHeader
        title="Theme Switcher"
        description="A button component for toggling between light and dark mode. Uses the outlined IconButton variant."
        figmaNodeId="576-4756"
        styles={styles}
      />

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Interactive Demo</h3>
        <div className={styles.row}>
          <div className={styles.iconButtonDemo}>
            <ThemeSwitcher />
            <span className={styles.iconButtonLabel}>
              Current: {theme === 'dark' ? 'Dark' : 'Light'}
            </span>
          </div>
        </div>
        <p className={styles.hint}>
          Click the button to toggle between light and dark mode. In dark mode, shows a sun icon
          (switch to light). In light mode, shows a moon icon (switch to dark).
        </p>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Implementation</h3>
        <p className={styles.hint}>
          The ThemeSwitcher uses the outlined IconButton (38px) with IconLightMode and IconDarkMode
          icons. It connects to the global theme state via useUIStore.
        </p>
      </div>
    </section>
  );
};
